import React, { useState, useEffect } from "react";
import { useNotify } from "../../../context/NotificationContext";
import { Card, Form, Button, Spin } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import masterService from "../../../services/masterService";
import { useNavigate } from "react-router-dom";
import { useCommon } from "../../../context/CommonContext";
import ReactQuillEditor from "../../../components/ReactQuillEditor";

const AboutUs = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { setPageTitle } = useCommon();
  // State management
  const [loading, setLoading] = useState(false);
  const [spinning, setSpinning] = useState(true);
  const notify = useNotify();

  // Load about us data
  useEffect(() => {
    setPageTitle("About Us");
    getAboutUs();
  }, [setPageTitle]);

  const getAboutUs = async () => {
    try {
      setSpinning(true);
      const response = await masterService.getAboutUs();

      if (response.data && response.data.status) {
        form.setFieldsValue({
          about_us_text: response.data.data,
        });
      } else {
        notify.error({ message: "Failed to fetch about us content" });
      }
    } catch (error) {
      console.error("Error fetching about us:", error);
      notify.error({ message: "Failed to fetch about us content" });
    } finally {
      setSpinning(false);
    }
  };

  // Handle form submission
  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const response = await masterService.updateAboutUs(values);

      if (response.data && response.data.status) {
        notify.success({
          message: response.data.message || "About Us saved successfully!",
        });
        navigate("/about-us");
      } else {
        notify.error({
          message: response.data.message || "Failed to save about us",
        });
        navigate("/about-us");
      }
    } catch (error) {
      console.error("Error saving about us:", error);
      notify.error({ message: "Failed to save about us" });
    } finally {
      setLoading(false);
    }
  };

  // Header content with user info

  return (
    <Spin spinning={spinning}>
      <Card className="m-6">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          style={{ maxWidth: "100%" }}
        >
          <Form.Item
            label="About Us Content"
            name="about_us_text"
            rules={[
              { required: true, message: "Please enter about us content" },
            ]}
          >
            {/* <TextArea
              rows={15}
              placeholder="Enter about us content here..."
              style={{ minHeight: "400px" }}
            /> */}
            <ReactQuillEditor
                      placeholder="Enter about us content here..."
                      Height={400}
                    />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              icon={<SaveOutlined />}
              size="large"
            >
              Save About Us
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Spin>
  );
};

export default AboutUs;
